// Status metadata + option lists for CLASSIC24 OS

export const SEMANTIC = {
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  orange: "bg-amber-50 text-amber-700 border-amber-200",
  red: "bg-red-50 text-red-700 border-red-200",
  blue: "bg-blue-50 text-blue-700 border-blue-200",
  grey: "bg-zinc-100 text-zinc-600 border-zinc-200",
};

export const SEMANTIC_DOT = {
  green: "bg-emerald-500",
  orange: "bg-amber-500",
  red: "bg-red-500",
  blue: "bg-blue-500",
  grey: "bg-zinc-400",
};

export const SEMANTIC_BAR = {
  green: "bg-emerald-500",
  orange: "bg-amber-500",
  red: "bg-red-500",
  blue: "bg-blue-500",
  grey: "bg-zinc-400",
};

export const SEMANTIC_HEX = {
  green: "#059669",
  orange: "#D97706",
  red: "#DC2626",
  blue: "#2563EB",
  grey: "#6B7280",
};

export const CONTENT_STATUS = {
  planned: { label: "Planned", color: "grey" },
  in_progress: { label: "In Progress", color: "orange" },
  ready_for_approval: { label: "Ready for Approval", color: "blue" },
  approved: { label: "Approved", color: "green" },
  posted: { label: "Posted", color: "green" },
};
export const CONTENT_STATUS_ORDER = ["planned", "in_progress", "ready_for_approval", "approved", "posted"];

// Work-type groups — route content to the right production pool
export const VIDEO_TYPES = ["reel", "video"];
export const DESIGN_TYPES = ["static", "carousel", "festival", "offer", "educational", "promotional", "event", "testimonial", "other"];

// Which home workspace each functional job_role lands on
export const JOB_WORKSPACE = {
  social_media_handler: "smm",
  designer: "design",
  video_editor: "video",
  account_manager: "account",
};

export const JOB_ROLE_LABEL = {
  manager: "Manager",
  social_media_handler: "Social Media Handler",
  designer: "Graphic Designer",
  video_editor: "Video Editor",
  copywriter: "Copywriter",
  account_manager: "Account Manager",
  other: "Team Member",
};

export const ASSIGN_ROLES = [
  { v: "social_media_handler", l: "Social Media Handler" },
  { v: "designer", l: "Graphic Designer" },
  { v: "video_editor", l: "Video Editor" },
  { v: "copywriter", l: "Copywriter" },
  { v: "account_manager", l: "Account Manager" },
  { v: "other", l: "Other" },
];

export const TASK_STATUS = {
  todo: { label: "To Do", color: "blue" },
  in_progress: { label: "In Progress", color: "orange" },
  completed: { label: "Completed", color: "green" },
  overdue: { label: "Overdue", color: "red" },
};

export const JOB_ROLES = [
  { v: "manager", l: "Manager" },
  { v: "social_media_handler", l: "Social Media Handler" },
  { v: "designer", l: "Designer" },
  { v: "video_editor", l: "Video Editor" },
  { v: "copywriter", l: "Copywriter" },
  { v: "account_manager", l: "Account Manager" },
  { v: "other", l: "Other" },
];

export const SHOOT_STATUS = {
  scheduled: { label: "Scheduled", color: "blue" },
  confirmed: { label: "Confirmed", color: "blue" },
  in_progress: { label: "In Progress", color: "orange" },
  completed: { label: "Completed", color: "green" },
  rescheduled: { label: "Rescheduled", color: "orange" },
  cancelled: { label: "Cancelled", color: "grey" },
};
export const SHOOT_STATUS_ORDER = ["scheduled", "confirmed", "in_progress", "completed", "rescheduled", "cancelled"];

export const PAYMENT_STATUS = {
  paid: { label: "Paid", color: "green" },
  partial: { label: "Partial", color: "orange" },
  overdue: { label: "Overdue", color: "red" },
  due_today: { label: "Due Today", color: "orange" },
  due_soon: { label: "Due Soon", color: "orange" },
  upcoming: { label: "Upcoming", color: "blue" },
  advance: { label: "Advance", color: "green" },
  cancelled: { label: "Cancelled", color: "grey" },
};

export const CLIENT_STATUS = {
  active: { label: "Active", color: "green" },
  paused: { label: "Paused", color: "orange" },
  completed: { label: "Completed", color: "blue" },
  inactive: { label: "Inactive", color: "grey" },
};

export const PRIORITY = {
  low: { label: "Low", color: "grey" },
  medium: { label: "Medium", color: "blue" },
  high: { label: "High", color: "red" },
};

export const HEALTH = {
  green: { label: "On Track", color: "green" },
  orange: { label: "Needs Attention", color: "orange" },
  red: { label: "Falling Behind", color: "red" },
};

export const PLATFORMS = [
  { v: "instagram", l: "Instagram" },
  { v: "facebook", l: "Facebook" },
  { v: "linkedin", l: "LinkedIn" },
  { v: "youtube", l: "YouTube" },
  { v: "youtube_shorts", l: "YouTube Shorts" },
  { v: "google_business", l: "Google Business" },
  { v: "other", l: "Other" },
];

export const CONTENT_TYPES = [
  { v: "static", l: "Static" },
  { v: "carousel", l: "Carousel" },
  { v: "reel", l: "Reel" },
  { v: "video", l: "Video" },
  { v: "story", l: "Story" },
  { v: "festival", l: "Festival" },
  { v: "offer", l: "Offer" },
  { v: "educational", l: "Educational" },
  { v: "promotional", l: "Promotional" },
  { v: "event", l: "Event" },
  { v: "testimonial", l: "Testimonial" },
  { v: "other", l: "Other" },
];

export const PAYMENT_METHODS = [
  { v: "upi", l: "UPI" },
  { v: "bank_transfer", l: "Bank Transfer" },
  { v: "cash", l: "Cash" },
  { v: "cheque", l: "Cheque" },
  { v: "gateway", l: "Payment Gateway" },
  { v: "other", l: "Other" },
];

export const BILLING_TYPES = [
  { v: "postpaid", l: "Postpaid — billed each cycle" },
  { v: "prepaid", l: "Prepaid — renewal / advance" },
];

export const BILLING_CYCLES = [
  { v: "monthly", l: "Monthly" },
  { v: "quarterly", l: "Quarterly" },
  { v: "half_yearly", l: "Half-yearly" },
  { v: "yearly", l: "Yearly" },
  { v: "one_time", l: "One-time" },
  { v: "custom", l: "Custom" },
];

export const BILLING_BASIS = [
  { v: "advance", l: "Advance — bill upfront" },
  { v: "arrears", l: "Arrears — bill after period" },
];

export const CLIENT_STATUSES = [
  { v: "active", l: "Active" },
  { v: "paused", l: "Paused" },
  { v: "completed", l: "Completed" },
  { v: "inactive", l: "Inactive" },
];

export const SHOOT_TYPES = [
  { v: "photo", l: "Photo Shoot" },
  { v: "video", l: "Video Shoot" },
  { v: "Product Shoot", l: "Product Shoot" },
  { v: "Reel Shoot", l: "Reel Shoot" },
  { v: "Property Shoot", l: "Property Shoot" },
  { v: "Food Shoot", l: "Food Shoot" },
  { v: "Event Coverage", l: "Event Coverage" },
];

export const EQUIPMENT = ["Camera", "iPhone", "Gimbal", "Drone", "Lights", "Microphone", "Tripod", "Other"];

export const TEAM_ROLES = [
  { v: "photographer", l: "Photographer" },
  { v: "videographer", l: "Videographer" },
  { v: "account_manager", l: "Account Manager" },
  { v: "assistant", l: "Assistant" },
];

export const ROLE_LABEL = {
  super_admin: "CEO / Super Admin",
  manager: "Manager",
  employee: "Employee",
};

export function label(map, key) {
  return map[key]?.label || key;
}

// ---- Special Days & Festivals ----
export const FESTIVAL_CATEGORY = {
  national: { label: "National", color: "blue" },
  religious: { label: "Religious", color: "orange" },
  tithi: { label: "Tithi / Vrat", color: "orange" },
  regional: { label: "Regional", color: "green" },
  awareness: { label: "Awareness", color: "blue" },
  professional: { label: "Professional", color: "grey" },
  marketing: { label: "Marketing", color: "red" },
  cultural: { label: "Cultural", color: "green" },
};

export const FESTIVAL_FAITH = {
  hindu: { label: "Hindu", color: "orange" },
  sikh: { label: "Sikh", color: "orange" },
  jain: { label: "Jain", color: "orange" },
  buddhist: { label: "Buddhist", color: "orange" },
  muslim: { label: "Muslim", color: "green" },
  christian: { label: "Christian", color: "blue" },
  parsi: { label: "Parsi", color: "red" },
  secular: { label: "Secular", color: "grey" },
};
